/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'financialStatus/good': {
    width: 42,
    height: 42,
    viewBox: '0 0 42 42',
    data: '<g _fill="none" fill-rule="evenodd"><path pid="0" d="M20.742 0c11.456 0 20.742 9.286 20.742 20.742 0 11.454-9.286 20.741-20.742 20.741C9.287 41.483 0 32.197 0 20.743 0 9.285 9.287 0 20.742 0" _fill="#FFD735"/><path pid="1" d="M20.921 31.381c3.271 0 5.415-2.12 5.923-4.377V27v.004c-4.154 1.211-7.905 1.22-11.844 0V27v.004c.507 2.257 2.651 4.377 5.921 4.377M14.36 14.85c1.454 0 2.631 1.249 2.631 2.788 0 1.54-1.177 2.788-2.632 2.788-1.453 0-2.63-1.248-2.63-2.788 0-1.54 1.177-2.788 2.63-2.788M27.125 14.85c1.454 0 2.632 1.249 2.632 2.788 0 1.54-1.178 2.788-2.632 2.788-1.453 0-2.63-1.248-2.63-2.788 0-1.54 1.177-2.788 2.63-2.788" _fill="#7D5C2A"/></g>'
  }
})
